<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="分类名称">
                <a-input v-model="queryParam.categoryName" placeholder="请输入分类名称" allow-clear @pressEnter="handleQuery" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" v-hasPermi="['livecourse:category:add']" @click="handleAdd">
          <a-icon type="plus" />新增分类
        </a-button>
      </div>
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list" :pagination="false" :bordered="tableBordered">
        <span slot="operation" slot-scope="text, record">
          <a v-hasPermi="['livecourse:category:edit']" @click="handleEdit(record)">修改</a>
          <a-divider type="vertical" />
          <a v-hasPermi="['livecourse:category:remove']" @click="handleDelete(record)">删除</a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <a-modal :visible="visible" :confirm-loading="saving" :title="form.id ? '修改课程分类' : '新增课程分类'" @cancel="visible = false" @ok="submitForm">
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
          <a-form-model-item label="分类名称" prop="categoryName">
            <a-input v-model="form.categoryName" :maxLength="100" placeholder="请输入分类名称" />
          </a-form-model-item>
          <a-form-model-item label="排序" prop="sort">
            <a-input-number v-model="form.sort" :min="0" :precision="0" style="width: 100%" />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageLiveCourseCategory,
  addLiveCourseCategory,
  editLiveCourseCategory,
  deleteLiveCourseCategory
} from '@/api/livecourse/liveCourseCategory'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'LiveCourseCategory',
  mixins: [tableMixin],
  data() {
    return {
      loading: false,
      saving: false,
      visible: false,
      list: [],
      total: 0,
      queryParam: { categoryName: undefined, pageNum: 1, pageSize: 10 },
      form: { id: undefined, categoryName: '', sort: 0 },
      rules: {
        categoryName: [{ required: true, whitespace: true, message: '请输入分类名称', trigger: 'blur' }],
        sort: [{ required: true, type: 'number', message: '请输入排序值', trigger: 'change' }]
      },
      columns: [
        { title: '分类名称', dataIndex: 'categoryName' },
        { title: '排序', dataIndex: 'sort', width: 100 },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, width: 160 }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true
      pageLiveCourseCategory(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
      }).finally(() => { this.loading = false })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = { categoryName: undefined, pageNum: 1, pageSize: 10 }
      this.getList()
    },
    handleAdd() {
      this.form = { id: undefined, categoryName: '', sort: 0 }
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleEdit(record) {
      this.form = { id: record.id, categoryName: record.categoryName, sort: record.sort }
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    submitForm() {
      if (this.saving) return
      this.$refs.form.validate(valid => {
        if (!valid) return
        const save = this.form.id ? editLiveCourseCategory : addLiveCourseCategory
        this.saving = true
        save(this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.getList()
        }).finally(() => { this.saving = false })
      })
    },
    handleDelete(record) {
      this.$confirm({
        title: '确认删除该课程分类？',
        content: '分类下有课程时不能删除。',
        onOk: () => deleteLiveCourseCategory(record.id).then(() => {
          this.$message.success('删除成功')
          this.queryParam.pageNum = 1
          this.getList()
        })
      })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageNum = 1
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
